import React from "react";
import FanStar from "./Content/FanStar";

const FanGroupBody = () => {
  return (
    <>
      <FanStar />
    </>
  );
};

export default FanGroupBody;
